import React from "react";
import "../sass/notfound.scss"

export default function NotFoundPage() {

    return (
        <section className="notfound-sec">
            <div className="notfound-card">
                <h1>Ops, acho que você está no lugar errado!</h1>
                <a href="/clinica-integrada"><b>clique aqui para voltar para página incial  </b></a>
            </div>

        </section>
    )

}